import React, { useState } from "react";
import { Card, CardBody, Input, Button, Container, Row, Col } from "reactstrap";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AIAssistant = () => {
    const [input, setInput] = useState("");
    const [messages, setMessages] = useState([]);

    const handleAskAI = async () => {
        if (!input) return;

        const userMessage = { text: input, sender: "user" };
        setMessages([...messages, userMessage]);

        try {
            const response = await axios.post(API_BASE_URL + "/ai/ask-ai", { question: input });
            const aiMessage = { text: response.data.response, sender: "ai" };
            setMessages([...messages, userMessage, aiMessage]);
        } catch (error) {
            console.error("Error fetching AI response:", error);
        }

        setInput("");
    };

    return (
        <div>

            <h4 className="text-center">AI Assistant</h4>
            <div
                className="chat-box border p-3 mb-3"
                style={{ height: "clamp(240px, 50vh, 480px)", overflowY: "auto" }}
            >
                {messages.map((msg, index) => (
                    <div key={index} className={`text-${msg.sender === "user" ? "right text-primary" : "left text-primary"}`}>
                        <p>{msg.text}</p>
                    </div>
                ))}
            </div>
            <Input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Ask a question..."
                className="mb-2"
            />
            <Button color="primary" block onClick={handleAskAI}>
                Ask AI
            </Button>

        </div>
    );
};

export default AIAssistant;
